module.exports = __webpack_public_path__ + "img/hand-raise-solid.fb9be139.svg";